// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-tests-MdmCardDemoPage-MdmCardForm-MdmCardForm-module__formBox--Z3P4_ {
  height: 100%;
  overflow: auto;
}
/*# sourceMappingURL=MdmCardForm.module.css.map */`, "",{"version":3,"sources":["webpack://./MdmCardForm.module.less","webpack://./src/pages/tests/MdmCardDemoPage/MdmCardForm/MdmCardForm.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,cAAA;ACCF;AACA,iDAAiD","sourcesContent":[".formBox {\n  height: 100%;\n  overflow: auto;\n}\n",".formBox {\n  height: 100%;\n  overflow: auto;\n}\n/*# sourceMappingURL=MdmCardForm.module.css.map */"],"sourceRoot":""}]);
// Exports
export var formBox = `src-pages-tests-MdmCardDemoPage-MdmCardForm-MdmCardForm-module__formBox--Z3P4_`;
export default ___CSS_LOADER_EXPORT___;
